module.exports = __webpack_public_path__ + "static/slide1.72de8955.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rtm/slide1.png
// module id = 536
// module chunks = 35783957827783